<template>
    <v-row no-gutters>
        <v-col class="flex-grow-0">
            <v-radio-group
                v-model="correctAnswerIdx"
                hide-details
                class="justify-space-between"
            >
                <template v-for="(answer, idx) in answers">
                    <v-radio
                        v-if="idx !== lastAnswerIdx"
                        :key="idx"
                        class="mx-0 mb-6"
                        color="primary"
                    ></v-radio>
                </template>
            </v-radio-group>
        </v-col>

        <v-col>
            <template v-for="(answer, idx) in answers">
                <v-text-field
                    @input="answerChange(idx, $event)"
                    :key="idx"
                    :value="answer"
                    :label="optionChar(idx)"
                    hide-details
                ></v-text-field>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
import idxToOptionChar from '@/tools/idxToOptionChar'

export default {
    computed: {
        answers: sync('questionbank/input@answers'),

        correctAnswerIdx: sync('questionbank/input@correctAnswerIdx'),

        lastAnswerIdx() {
            return this.answers.length - 1
        },

        beforeLastIdx() {
            return this.lastAnswerIdx - 1
        },
    },

    methods: {
        optionChar(idx) {
            if (idx === this.lastAnswerIdx) {
                return `Tambah opsi ${idxToOptionChar(idx)}`
            }

            return `Opsi ${idxToOptionChar(idx)}`
        },

        answerChange(idx, value) {
            this.$store.set(`questionbank/input@answers.${idx}`, value)

            if (idx === this.lastAnswerIdx && value != null) {
                this.answers.push(null)
            } else if (idx === this.beforeLastIdx && value == '') {
                this.answers.pop()
            }
        },
    },
}
</script>
